import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormExtendedValidationSchema = Yup.object().shape({
    name: Yup.string().required(validationMessages.required),
    email: Yup.string().email().required(validationMessages.required),
    password: Yup.string().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    }),
    marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required),
    marketing_sms: Yup.boolean()
});
